import { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Button,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import currency from "currency.js";
import KeyInDiscountEntry from "./KeyInDiscountEntry";

export default function Discount(props) {
  const { max } = props;

  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);

  const onSubmit = () => {
    props.onChange(value);
    setOpen(false);
  };

  const getPercentButton = (factor) => {
    const discountValue = currency(max).multiply(factor);
    return (
      <Button
        variant="outlined"
        color="secondary"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "5rem",
          width: "100%",
          minWidth: "5rem",
        }}
        onClick={() => setValue(discountValue.value)}
      >
        <Typography variant="h5">{factor * 100}%</Typography>
        <Typography variant="overline">{discountValue.format()}</Typography>
      </Button>
    );
  };

  return (
    <Box>
      <Button
        onClick={() => {
          setOpen(true);
          setValue(props.value || 0);
        }}
        size="small"
      >
        DISCOUNT
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true} maxWidth="xs">
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Discount</Typography>

          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex" }}>
            <KeyInDiscountEntry amount={value} onChange={(val) => setValue(val)} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
                paddingBottom: "1rem",
              }}
            >
              {getPercentButton(0.05)}
              {getPercentButton(0.1)}
              {getPercentButton(0.15)}
              {getPercentButton(0.2)}
              <Button
                variant="contained"
                color="secondary"
                onClick={(e) => {
                  setValue("");
                }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: "5rem",
                  width: "100%",
                  minWidth: "5rem",
                  fontSize: "1.7rem",
                  fontWeight: "600",
                }}
              >
                C
              </Button>
            </Box>
          </Box>
          {+value > +max && (
            <Box textAlign="center">
              <Typography variant="caption" color="error">
                Discount cannot be greater than {currency(max).format()}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button fullWidth variant="outlined" color="secondary" onClick={() => setOpen(false)}>
            CANCEL
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={+value > +max}
          >
            SAVE
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
